export function setSessionStorageItem<T>(key: string, value: T) {
  if (typeof window === 'undefined') return;
  sessionStorage.setItem(key, JSON.stringify(value));
}
